/**
 * Converts the cockpit's raw CreateFilter object into the flat string-keyed
 * param format expected by the AI insight API.
 *
 * Input shape (from Cockpit's CreateFilter useMemo):
 *   { contractId__in: [42, 43], createdDate__gte: "2026-01-01T00:00:00",
 *     createdDate__lte: "2026-02-28T23:59:59", contractStatus__eq: "All" }
 *
 * Output shape (expected by API):
 *   { contractId: "42", startDate: "2026-01-01", endDate: "2026-02-28" }
 */
export function buildAiBaseParams(filterParams: Record<string, any>): Record<string, string> {
  const contractIds: any[] = filterParams.contractId__in ?? [];
  const contractId = Array.isArray(contractIds) && contractIds.length > 0 ? contractIds.join(",") : "0";

  const startDate = filterParams.createdDate__gte ? (filterParams.createdDate__gte as string).substring(0, 10) : "";

  const endDate = filterParams.createdDate__lte ? (filterParams.createdDate__lte as string).substring(0, 10) : "";

  return { contractId, startDate, endDate };
}
